import { Component, OnInit, Input, SimpleChanges, ViewChild, ElementRef, Renderer2 } from '@angular/core';
import { NavigationEnd, Router, ActivatedRoute } from '@angular/router';
import { AssessmentService } from 'src/app/core/services/assessment.service';
import { CategoryService } from 'src/app/core/services/category.service';
import { CommonService } from 'src/app/core/services/common.service';
import { StorageService } from 'src/app/core/services/storage.service';
import { Location } from '@angular/common';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { UnansweredQuestionModalComponent } from 'src/app/components/unanswered-question-modal/unanswered-question-modal.component';

@Component({
  selector: 'app-questionnaire-tabs',
  templateUrl: './questionnaire-tabs.component.html',
  styleUrls: ['./questionnaire-tabs.component.css']
})
export class QuestionnaireTabsComponent implements OnInit {
  @Input() assessmentDetails: any;
  @Input() totalEachTypeQuestions: any;
  questionnaireType!: string;
  quesLanguage!: string;
  isArabic!: boolean;
  subscription: any;
  isResubmit: any;
  isView: any;
  generalCount: any;
  inherentCount: any;
  controlCount: any;
  isChecker!: boolean;
  isMakerCheckerEnabled!: boolean;
  isNoUnAnsweredQues: boolean = false;
  modalRef!: BsModalRef;
  isShowAssessmentRating: boolean = false;
  assessmentRatings!: any;
  @Input() showGeneralSection: boolean = true;
  @Input() showInherentSection: boolean = true;
  @Input() showControlSection: boolean = true;

  constructor(private activateRoute: ActivatedRoute, private route: Router, private storageService: StorageService,
    private assessmentService: AssessmentService, private commonService: CommonService,
    private categoryService: CategoryService, private el: ElementRef, private location: Location,
    private modalService: BsModalService) {
    this.subscription = this.activateRoute.queryParams.subscribe((queryParam: any) => {
      if (queryParam.hasOwnProperty('questionnairetype')) {
        this.questionnaireType = queryParam.questionnairetype;
        if (queryParam.hasOwnProperty('action') && queryParam.action == 'resubmit') {
          this.isResubmit = true;
          this.isView = false;
        } else if (queryParam.hasOwnProperty('action') && queryParam.action == 'view') {
          this.isResubmit = false;
          this.isView = true;
        } else {
          this.isResubmit = false;
          this.isView = false;
        }
      }
    });
  }

  ngOnInit(): void {
    this.isArabic = this.storageService.getSessionStorageData('isArabic');
    this.isChecker = this.storageService.getSessionStorageData('isChecker');
    this.isMakerCheckerEnabled = this.storageService.getSessionStorageData('isMakerCheckerEnabled');
    // console.log(this.assessmentDetails)
    this.isShowAssessmentRating = this.assessmentDetails?.assessmentratingpreview ? true : false;
    if (this.isView && this.isShowAssessmentRating) {
      this.fetchAssessmentRatings();
    }
    //commenting as of now
    // this.categoryService.reduceQuesCountValue$.subscribe((value) => {
    //   let reduceQuesCount = value;
    //   //console.log('reduceQuesCount: ', reduceQuesCount);

    //   if (this.questionnaireType == 'General') {
    //     this.generalCount = this.generalCount - reduceQuesCount;
    //   } else if (this.questionnaireType == 'Inherent Risk') {
    //     this.inherentCount = this.inherentCount - reduceQuesCount;
    //   } else if (this.questionnaireType == 'Controls') {
    //     this.controlCount = this.controlCount - reduceQuesCount;
    //   }
    // });
  }

  fetchAssessmentRatings() {
    const rqstBody = {
      assessmentAccountGuid: this.assessmentDetails.questionnaireAccountGuid,
      assessmentUnit: this.assessmentDetails.assessmentunitguid
    }
    this.assessmentService.fetchAssessmentRatings(rqstBody).subscribe((res: any) => {
      let decryptedData = this.commonService.decryptUsingAES256(res?.data);
      let resp = JSON.parse(JSON.stringify(decryptedData));
      if (resp && resp?.assessmentRatings && resp?.assessmentRatings?.length > 0) {
        const data = resp?.assessmentRatings[0];
        const ratings = {
          CE: data?.CumulativeControlEffectivenessRating,
          IR: data?.CumulativeInherentRiskRating,
          // RIR: data?.FinalResidualImpactRating ? data?.FinalResidualImpactRating : data?.ResidualImpactRating,
          // RLR: data?.FinalResidualLikelihoodRating ? data?.FinalResidualLikelihoodRating : data?.ResidualLikelihoodRating,
          RIR: data?.ResidualImpactRating,
          RLR: data?.ResidualLikelihoodRating,
          AO: data?.AssessmentOutcome
        }
        this.assessmentRatings = ratings;
      }
      //console.log('ratings in tabs: ', this.assessmentRatings);
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    //console.log(changes);
    if (changes.hasOwnProperty('totalEachTypeQuestions')) {
      this.generateCountOfEacTypeQues();
    }
  }

  switchQuestionnaire(questionnaireTypeName: string) {
    if (this.isView) {
      this.route.navigate(['submit-assessment'], { queryParams: { questionnairetype: questionnaireTypeName, action: 'view' } });
    }
    else if (this.isResubmit) {
      this.route.navigate(['submit-assessment'], { queryParams: { questionnairetype: questionnaireTypeName, action: 'resubmit' } });
    }
    else {
      this.route.navigate(['submit-assessment'], { queryParams: { questionnairetype: questionnaireTypeName } });
    }
  }

  navigateToUnansweredQues(): void {
    this.isNoUnAnsweredQues = false;

    const rqstBodyTotalNo = {
      questionnaire: this.assessmentDetails?.questionnaireguid,
      assessmentUnit: this.assessmentDetails?.assessmentunitguid,
      isChecker: this.isChecker,
      isMakerCheckerEnabled: this.isMakerCheckerEnabled
    };

    this.assessmentService.fetchTotalNoOfQues(rqstBodyTotalNo).subscribe((res: any) => {
      if (!res?.data) {
        // handle error or empty data here if needed
        return;
      }

      const decryptedData = this.commonService.decryptUsingAES256(res.data);
      const resp = typeof decryptedData === 'string' ? JSON.parse(decryptedData) : decryptedData;

      const {
        notAnswered = 0,
        totalQuestions = 0,
        totalAnswers = 0,
        totalReviewedAnswers = 0,
        totalRejectedAnswers = 0,
        totalEachTypeQuestions = []
      } = resp;

      // Conditions for no unanswered questions
      const noUnansweredForMaker = !this.isResubmit && !this.isChecker && notAnswered === 0 && totalQuestions === totalAnswers;
      const noUnansweredForChecker = !this.isResubmit && this.isChecker && notAnswered === 0 && totalAnswers === totalReviewedAnswers;
      const noUnansweredForResubmit = this.isResubmit && totalRejectedAnswers === 0 && totalQuestions === totalAnswers;

      if (noUnansweredForMaker || noUnansweredForChecker || noUnansweredForResubmit) {
        this.isNoUnAnsweredQues = true;
        this.modalRef = this.modalService.show(UnansweredQuestionModalComponent);
        return;
      }

      if (Array.isArray(totalEachTypeQuestions) && totalEachTypeQuestions.length > 0) {
        this.isNoUnAnsweredQues = false;

        let unAnsweredSections = [];

        if (this.isResubmit) {
          unAnsweredSections = totalEachTypeQuestions.filter(section => section?.rejected > 0);
        }
        else if (this.isChecker) {
          unAnsweredSections = totalEachTypeQuestions.filter(section => section?.reviewed < section?.answered);
        }
        else {
          unAnsweredSections = totalEachTypeQuestions.filter(section => section?.answered < section?.totalcount);
        }

        if (unAnsweredSections.length) {
          // Select section with smallest value (as pop() gets last element)
          const section = unAnsweredSections.sort((a, b) => b.value - a.value).pop()?.name;

          if (section) {
            const queryParams: any = { questionnairetype: section, revisittype: 'unanswered' };
            if (this.isResubmit) {
              queryParams.action = 'resubmit';
            }
            this.route.navigate(['submit-assessment'], { queryParams });
          }
        }
      }
    });
  }

  navigateToUnansweredQuesold() {
    let allQuestions: any;
    let allAnswers: any;
    this.isNoUnAnsweredQues = false;
    let rqstBodyTotalNo = {
      questionnaire: this.assessmentDetails?.questionnaireguid,
      assessmentUnit: this.assessmentDetails?.assessmentunitguid,
      isChecker: this.isChecker,
      isMakerCheckerEnabled: this.isMakerCheckerEnabled
    };
    this.assessmentService.fetchTotalNoOfQues(rqstBodyTotalNo).subscribe((res: any) => {
      let decryptedData = this.commonService.decryptUsingAES256(res?.data);
      let resp = JSON.parse(JSON.stringify(decryptedData));
      //console.log('finally number of questions in tabs: ', resp);
      if (!this.isResubmit && !this.isChecker && resp?.notAnswered == 0 && resp?.totalQuestions == resp?.totalAnswers) {
        this.isNoUnAnsweredQues = true;
        this.modalRef = this.modalService.show(UnansweredQuestionModalComponent, {});
      }
      else if (!this.isResubmit && this.isChecker && resp?.notAnswered == 0 && resp?.totalAnswers == resp?.totalReviewedAnswers) {
        this.isNoUnAnsweredQues = true;
        this.modalRef = this.modalService.show(UnansweredQuestionModalComponent, {});
      }
      else if (this.isResubmit && resp?.totalRejectedAnswers == 0 && resp?.totalQuestions == resp?.totalAnswers) {
        this.isNoUnAnsweredQues = true;
        this.modalRef = this.modalService.show(UnansweredQuestionModalComponent, {});
      }
      else if (resp?.totalEachTypeQuestions?.length > 0) {
        this.isNoUnAnsweredQues = false;
        let unAnsweredSections;

        if (this.isResubmit) {
          unAnsweredSections = resp?.totalEachTypeQuestions?.filter((section: any) =>
            section?.rejected > 0);
        }
        else if (this.isChecker) {
          unAnsweredSections = resp?.totalEachTypeQuestions?.filter((section: any) =>
            section?.reviewed < section?.answered);
        }
        else {
          unAnsweredSections = resp?.totalEachTypeQuestions?.filter((section: any) =>
            section?.answered < section?.totalcount);
        }

        let section = unAnsweredSections && unAnsweredSections.length > 0 &&
          unAnsweredSections.sort((x: any, y: any) => y.value - x.value).pop()?.name;
        //console.log("section:", section);
        if (section) {
          if (this.isResubmit) {
            this.route.navigate(['submit-assessment'], { queryParams: { questionnairetype: section, action: 'resubmit', revisittype: 'unanswered' } });
          }
          else {
            this.route.navigate(['submit-assessment'], { queryParams: { questionnairetype: section, revisittype: 'unanswered' } });
          }
        }
      }
    });


  }

  ngOnDestroy() {
    this.unsubscribe();
  }

  unsubscribe() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  generateCountOfEacTypeQues() {
    if (this.totalEachTypeQuestions && this.totalEachTypeQuestions.length > 0) {
      if (this.totalEachTypeQuestions[0].name == 'General') {
        if (!this.isResubmit) {
          if (this.totalEachTypeQuestions[0].totalcount <= 0) {
            this.showGeneralSection = false;
          }
          else {
            this.showGeneralSection = true;
          }
        }
        let pendingQues;
        if (this.isChecker) {
          pendingQues = this.totalEachTypeQuestions[0].totalcount - this.totalEachTypeQuestions[0].reviewed;
        } else {
          pendingQues = this.totalEachTypeQuestions[0].totalcount - this.totalEachTypeQuestions[0].answered;
        }

        if (pendingQues < 0) {
          this.generalCount = 0;
        } else {
          this.generalCount = pendingQues;
        }
      } else {
        this.generalCount = 0;
      }
      if (this.totalEachTypeQuestions[1].name == 'Inherent Risk') {
        if (!this.isResubmit) {
          if (this.totalEachTypeQuestions[1].totalcount <= 0) {
            this.showInherentSection = false;
          }
          else {
            this.showInherentSection = true;
          }
        }
        let pendingQues;
        if (this.isChecker) {
          pendingQues = this.totalEachTypeQuestions[1].totalcount - this.totalEachTypeQuestions[1].reviewed;
        } else {
          pendingQues = this.totalEachTypeQuestions[1].totalcount - this.totalEachTypeQuestions[1].answered;
        }
        if (pendingQues < 0) {
          this.inherentCount = 0;
        } else {
          this.inherentCount = pendingQues;
        }
      } else {
        this.inherentCount = 0;
      }
      if (this.totalEachTypeQuestions[2].name == 'Controls') {
        if (!this.isResubmit) {
          if (this.totalEachTypeQuestions[2].totalcount <= 0) {
            this.showControlSection = false;
          }
          else {
            this.showControlSection = true;
          }
        }
        let pendingQues;
        if (this.isChecker) {
          pendingQues = this.totalEachTypeQuestions[2].totalcount - this.totalEachTypeQuestions[2].reviewed;
        } else {
          pendingQues = this.totalEachTypeQuestions[2].totalcount - this.totalEachTypeQuestions[2].answered;
        }
        if (pendingQues < 0) {
          this.controlCount = 0;
        } else {
          this.controlCount = pendingQues;
        }
      } else {
        this.controlCount = 0;
      }
      // this.generalCount = this.totalEachTypeQuestions[0].name == 'General' ? 
      // (this.totalEachTypeQuestions[0].totalcount - this.totalEachTypeQuestions[0].answered) : 0;

      // this.inherentCount = this.totalEachTypeQuestions[1].name == 'Inherent Risk' ? 
      // (this.totalEachTypeQuestions[1].totalcount - this.totalEachTypeQuestions[1].answered) : 0;

      // this.controlCount = this.totalEachTypeQuestions[2].name == 'Controls' ? 
      // (this.totalEachTypeQuestions[2].totalcount - this.totalEachTypeQuestions[2].answered) : 0;
    }
  }

}
